<template>
  <div class="resource-center">
    <!-- 轮播图 -->
    <div class="swiper">
      <Swiper boxHeight='120px' />
    </div>

    <div class="nav-bar-box">
      <div class="nav-bar">
        <el-radio-group class="nav-bar-list" v-model="navBarRoute">
          <el-radio class="nav-bar-item" label="/resource-center/cloud-resource">安道云资源</el-radio>
          <el-radio class="nav-bar-item" label="/resource-center/sync-textbook">同步教材资源</el-radio>
        </el-radio-group>

        <div>
        </div>
      </div>
    </div>

    <!-- 显示子路由 -->
    <router-view />

  </div>
</template>

<script>
// 轮播图
import Swiper from "@/components/content/Swiper";
import utils from "@/util/index";
import { getUserMsg } from "@/network/loginRequest/api";

export default {
  name: "ResourceCenter",
  components: {
    Swiper
  },
  data() {
    return {
      //当前路由路径
      navBarRoute: this.$route.path
    };
  },

  created() {
    if (!this.$store.state.isLogin) {
      if (utils.getCookie("token")) {
        let token = utils.getCookie("token");
        this.$bus.exitLogin();

        utils.setSess("loginMessage", token);
        getUserMsg().then(res => {
          if (res.data.success) {
            //修改vuex的登录状态
            this.$store.commit("isLogin", true);
            //修改用户id
            this.$store.commit("setUserId", res.data.data.userId);

            //修改用户信息--------------------------------------------
            let obj = res.data.data;
            let user = this.$store.state.user;
            let newUser = {};
            for (const key in user) {
              if (user.hasOwnProperty(key)) {
                newUser[key] = user[key];
              }
            }

            //直接修改user会越过vuex--------------------------------------------
            for (const key in obj) {
              if (obj.hasOwnProperty(key)) {
                newUser[key] = obj[key];
              }
            }

            this.$store.commit("setUser", newUser);
            //把vuex保存在浏览器 防止用户刷新页面时vuex数据重置
            utils.setSess("store", JSON.stringify(this.$store.state));
            utils.clearAmdoxCookie("token");
            this.$router.go(0);
          }
        });
      }
    }
  },

  watch: {
    //点击跳转子路由
    navBarRoute(newVal) {
      this.$router.push(newVal);
    }
  }
};
</script>

<style lang="less" scoped>
//激活时和悬浮时字体颜色
@acitveColor: #24ba58;
//字体基础颜色
@fontColor: #333;

.resource-center {
  .nav-bar-box {
    box-shadow: 0 0 5px 1px #ccc;
    background-color: #fff;
    height: 40px;
    display: flex;
    justify-content: center;

    .nav-bar {
      min-width: 1200px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-weight: 400;
      font-size: 14px;
      color: @fontColor;

      .nav-bar-list {
        /deep/.el-radio__input {
          display: none;
        }

        /deep/.el-radio__label {
          font-weight: 400;
          padding-left: 0;
          margin-left: 20px;
          color: @fontColor;
        }

        /deep/.el-radio__label:hover {
          color: @acitveColor;
        }

        /deep/.el-radio__input.is-checked + .el-radio__label {
          color: @acitveColor;
        }
      }
    }
  }
}
</style>